import loadable from '@loadable/component';

export default loadable(
  () => import(/* webpackChunkName: "desktop-builtin-imgsearch" */ './Container')
);
